module.exports = __webpack_public_path__ + "media/images/emblems/Saint-Barthelemy-coat_of_arms-95f7f5a3965822b1eaa96bbeb4a9548a.svg";